import React from "react";
import styled, { keyframes } from "styled-components";
import { brandTheme } from "../../../theme";

const loaderAnimation = keyframes`
    from, 0% {
        transform: translateX(0)
    }
    50% {
        transform: translateX(25%)
    }
    100% {
        transform: translateX(0)
    }
`;

const Wrapper = styled.div`
  top: 0;
  left: 0%;
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: 7px;
`;

const LoadingBar = styled.div`
  background-color: ${brandTheme.brand.secondary};
  width: 80%;
  height: 5px;
  animation: ${loaderAnimation} 2s ease-in-out infinite;
`;

const circleLoaderAnimation = keyframes`
from, 
0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const CircleLoader = styled.div`
  width: 32px;
  height: 32px;
  border: 2px solid ${brandTheme.brand.secondary};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  animation: ${circleLoaderAnimation} 2s ease-in-out infinite;
`;

export const Loader = ({ type }) => {
  if (type === "circle") {
    return <CircleLoader />;
  }

  return (
    <Wrapper>
      <LoadingBar />
    </Wrapper>
  );
};
